import FloatingIconsRendererComponent from "@/components/common-components/floating-icons-renderer/FloatingIconsRendererComponent";
import "./ProjectComponent.scss";
import { Outlet } from "react-router-dom";
import { ImageConfig } from "@/constants";
import FooterComponent from "@/components/common-components/footer/FooterComponent.tsx";
import HeaderUserIconComponent from "@/components/common-components/header-user-icon/HeaderUserIconComponent.tsx";


const ProjectComponent = () => {

    return (
        <div className="flex flex-col min-h-screen bg-[#0a0a0a] text-white relative overflow-hidden on-boarding-layout">
            <header className="flex flex-col justify-between relative z-10">
                <div className="flex justify-between items-center p-4">
                    <ImageConfig.MediumLogo/>
                   <HeaderUserIconComponent/>
                </div>
            </header>
            <Outlet/>
            <FloatingIconsRendererComponent/>
            <FooterComponent/>
        </div>
    );

};

export default ProjectComponent;
